import './App.css';
import Navbar from './Components/Navbar/Navbar';
import Sec1Home from './Components/Sec1Home/Sec1Home';
import Sec2Why from './Components/Sec2Why/Sec2Why';
import Sec3GCC from './Components/Sec3GCC4.0/Sec3GCC';
import Sec4Evolution from './Components/Sec4Evolution/Sec4Evolution';
import Sec5AcademicStrength from './Components/Sec5AcademicStrength/Sec5AcademicStrength';
import Sec6Form from './Components/Sec6Form/Sec6Form';
import Sec7Maturity from './Components/Sec7Maturity/Sec7Maturity';
import Sec8Role from './Components/Sec8Role/Sec8Role';
import Sec9GrowingConfidence from './Components/Sec9GrowingConfidence/Sec9GrowingConfidence';
import Sec10Contactform from './Components/Sec10Contactform/Sec10Contactform';
import Footer from './Components/Footer/Footer';
import FAQSection from './Components/faqSection/FAQSection';

function App() {

  return (
    <div className="App">
      <Navbar />
      <Sec1Home />
      <Sec2Why />
      <Sec3GCC />
      <Sec4Evolution />
      {/* <Sec5AcademicStrength /> */}
      <Sec7Maturity />
      <Sec6Form />
      <Sec8Role />
      <Sec9GrowingConfidence />
      <Sec10Contactform />
      <FAQSection />
      <Footer />
    </div>
  );
}

export default App;
